import React, { useState } from "react"
import styled from "@emotion/styled"
import { css } from "@emotion/core"
import { mq, fontSize } from "../mixins"
import Modal from "../Modal/modal"

import "./leadership.scss"

const Leadership = props => {
  const [openedModalInfo, setOpenedModalInfo] = useState(null)

  const LeadershipChart = styled("div")`
  position: relative;
  background: url(${props => props.bg});
  background-position: bottom center;
  background-size: cover;
  h2,
  h3 {
    text-transform: uppercase;
  }
  h2 {
    text-align: center;
  }
  h5 {
    text-transform: uppercase;
    position: relative;
    display: inline-block;
    margin: 0;
    line-height: 1.3;
    border-bottom: 1px solid #000;
    ${fontSize(22, 24)};
  }
  p {
    font-weight: 600;
    color: rgba(97, 97, 97, 1);
    padding-top: 10px;
    /* line-height: 1.3; */
    /* ${fontSize(13, 16)} */
  }
`

  const leadershipChartContainer = css`
    .leadershipChart__container___border {
      width: 80%;
      height: 1px;
      border-bottom: 1px solid #000;
      margin: 42px auto 0 auto;
      ${mq("smTablet")} {
        max-width: 375px;
        margin-top: 65px;
      }
    }
  `

  const leadershipChartContainerMain = css`
    ${mq("smTablet")} {
      display: flex;
      width: 100%;
      margin: 0 auto;
    }
    ${mq("tablet")} {
      max-width: 800px;
    }

    .main__leadership {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      width: 90%;
      margin: 34px auto 0 auto;
      ${mq("mobile")} {
        width: 73%;
        max-width: 250px;
      }
      ${mq("tablet")} {
        flex-direction: column;
        justify-content: center;
        width: 30%;
        max-width: 100%;
      }
    }
    .main__leadership__profile {
      width: 72px;
      height: 138px;
      flex: none;
      img {
        display: block;
        width: 72px;
        height: auto;
      }
      ${mq("tablet")} {
        width: 100%;
        img {
          transition: width 0.3s ease;
          width: 128px;
          margin: 0 auto;
          :hover {
            width: 138px;
            cursor: pointer;
          }
        }
      }
    }
    .main__leadership__content {
      width: calc(100% - 85px);
      flex: none;
      ${mq("tablet")} {
        width: 100%;
        margin-top: 24px;
        text-align: center;
      }
      h5 {
        cursor: pointer;
        :hover {
          color: #747474;
        }
      }
    }
  `

  const leadershipChartContainerSupporting = css`
    display: flex;
    width: 90%;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;
    margin: 8px auto 56px auto;
    ${mq("smTablet")} {
      max-width: 900px;
      margin-top: 0;
      margin-bottom: 6%;
    }
    .supporting__leadership__content {
      width: 48%;
      flex: none;
      margin-top: 32px;
      ${mq("smTablet")} {
        width: 30%;
      }
      ${mq("tablet")} {
        text-align: center;
        margin-top: 5.5%;
      }
      h5 {
        cursor: pointer;
        :hover {
          color: #747474;
        }
      }
    }
  `

  const openModal = (e, leadership) => {
    setOpenedModalInfo({
      ...leadership,
    })
  }

  const mainLeader = Object.keys(props.main_leadership).map((item, index) => {
    return (
      <div className="main__leadership" key={index}>
        <div className="main__leadership__profile">
          <a onClick={e => openModal(e, props.main_leadership[item])}>
            <img
              src={props.main_leadership[item].file.url}
              alt={props.main_leadership[item].file.description}
            />
          </a>
        </div>
        <div className="main__leadership__content">
          <a onClick={e => openModal(e, props.main_leadership[item])}>
            <h5>{props.main_leadership[item].leadership_name}</h5>
          </a>
          <div className="main__leadership__content__border"></div>
          <p
            dangerouslySetInnerHTML={{
              __html: props.main_leadership[item].leadership_position.replace(
                /(?:\r\n|\r|\n)/g,
                "<br />"
              ),
            }}
          ></p>
        </div>
      </div>
    )
  })
  return (
    <LeadershipChart className="leadershipChart">
      <div
        className="leadershipChart__container"
        css={leadershipChartContainer}
      >
        <h2 className="headline">{props.headline}</h2>
        <div
          className="leadershipChart__container--main"
          css={leadershipChartContainerMain}
        >
          {mainLeader}
        </div>
        <div className="leadershipChart__container___border"></div>
        <div
          className="leadershipChart__container--supporting"
          css={leadershipChartContainerSupporting}
        >
          {props.modular_blocks.map((item, index) => {
            return (
              <div
                className="supporting__leadership__content"
                key={`${index}-supportingLeadership`}
              >
                <a onClick={e => openModal(e, item.secondary_leadership)}>
                  <h5>{item.secondary_leadership.leadership_name}</h5>
                </a>
                <p>{item.secondary_leadership.leadership_position}</p>
              </div>
            )
          })}
        </div>
      </div>

      {openedModalInfo ? <Modal {...openedModalInfo} /> : null}
    </LeadershipChart>
  )
}

export default Leadership
